<template>
  <div class="venueOrders">
    <div class="tabsBox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部订单" name="all"></el-tab-pane>
        <el-tab-pane label="待使用" name="2"></el-tab-pane>
        <!--          <el-tab-pane label="待支付" name="1">待支付</el-tab-pane>-->
        <!--          <el-tab-pane label="已支付" name="2">已支付</el-tab-pane>-->
        <el-tab-pane label="已完成" name="3"></el-tab-pane>
        <!--          <el-tab-pane label="已退款" name="4">已退款</el-tab-pane>-->
        <el-tab-pane label="已取消" name="4"></el-tab-pane>
      </el-tabs>
    </div>
    <evnetTables :order-status="activeName"></evnetTables>
  </div>
</template>

<script>
import evnetTables from "./componets/evnetTables";

export default {
  name: "evnetOrders",
  components: {
    evnetTables
  },
  data () {
    return {
      activeName: "all"
    }
  },
  created () {
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event);
    }
  }
}
</script>

<style lang="less" scoped>
.venueOrders {
  border: 1px solid #cecece;
  width: 100%;
  padding: 10px 20px 20px;

  .tabsBox {
    ::v-deep .el-tabs__item {
      font-size: 19px;
    }

    ::v-deep tabs__item.is-top:nth-child(2) {
      padding-left: 10px !important;
    }
  }

  .filterBar {
    height: 100px;
    border: 1px solid red;
  }
}
</style>
